var translate = {
// translation missing for [keys.SUB_subscriptions]
// translation missing for [keys.SUB_perMonth]
// translation missing for [keys.SUB_yourActiveSub]
// translation missing for [keys.SUB_cancel]
// translation missing for [keys.SUB_upgradePremium]
// translation missing for [keys.SUB_upgrade]
// translation missing for [keys.SUB_cancelDisabledTooltip]
// translation missing for [keys.SUB_planUpdatedSuccess]
// translation missing for [SUB_reason]
// translation missing for [SUB_reasonTitle]
// translation missing for [SUB_reasonOption1]
// translation missing for [SUB_reasonOption2]
// translation missing for [SUB_reasonOption3]
// translation missing for [SUB_reasonOther]
// translation missing for [SUB_selectPlan]
// translation missing for [SUB_reasonRequired]
// translation missing for [SUB_reasonMinLength]
// translation missing for [keys.SUB_subscriptionCancellationSuccess]
// translation missing for [keys.SUB_cancelDisabledwarning]
// translation missing for [keys.SUB_subscriptionTitle]
// translation missing for [keys.SUB_subscriptionCancellationWarning]
// translation missing for [keys.SUB_subscriptionCancellationTooltip]
// translation missing for [keys.SUB_subscriptionCancelRevokedSuccess]
// translation missing for [keys.SUB_revokeCancellation]
// translation missing for [keys.SUB_statusActive]
// translation missing for [keys.SUB_statusCancelled]
// translation missing for [keys.SUB_statusPending]
// translation missing for [keys.SUB_statusPendingDescription]
// translation missing for [keys.SUB_changePlan]
// translation missing for [keys.SUB_switchToStandard]
// translation missing for [keys.SUB_planAlreadyChangedThisMonth]
// translation missing for [keys.SUB_confirmPlanChange]
// translation missing for [keys.SUB_selectTargetPlan]
// translation missing for [keys.SUB_currentTerm]
// translation missing for [keys.SUB_cancellationWindow]
// translation missing for [keys.SUB_renewalTerm]
// translation missing for [keys.SUB_renewalTermMonths]
// translation missing for [keys.SUB_cancelDisabledCommitmentTooltip]
};
export default translate;
//# sourceMappingURL=data:application/json;base64,eyJ2ZXJzaW9uIjozLCJmaWxlIjoicHQtYnIuanMiLCJzb3VyY2VSb290IjoiIiwic291cmNlcyI6WyJwdC1ici50cyJdLCJuYW1lcyI6W10sIm1hcHBpbmdzIjoiQUFBQSxJQUFNLFNBQVMsR0FBNEI7QUFDekMsbURBQW1EO0FBQ25ELDhDQUE4QztBQUM5QyxtREFBbUQ7QUFDbkQsNENBQTRDO0FBQzVDLG9EQUFvRDtBQUNwRCw2Q0FBNkM7QUFDN0MsMkRBQTJEO0FBQzNELHdEQUF3RDtBQUN4RCx1Q0FBdUM7QUFDdkMsNENBQTRDO0FBQzVDLDhDQUE4QztBQUM5Qyw4Q0FBOEM7QUFDOUMsOENBQThDO0FBQzlDLDRDQUE0QztBQUM1QywyQ0FBMkM7QUFDM0MsK0NBQStDO0FBQy9DLGdEQUFnRDtBQUNoRCxxRUFBcUU7QUFDckUsMkRBQTJEO0FBQzNELHVEQUF1RDtBQUN2RCxxRUFBcUU7QUFDckUscUVBQXFFO0FBQ3JFLHNFQUFzRTtBQUN0RSx3REFBd0Q7QUFDeEQsa0RBQWtEO0FBQ2xELHFEQUFxRDtBQUNyRCxtREFBbUQ7QUFDbkQsOERBQThEO0FBQzlELGdEQUFnRDtBQUNoRCxzREFBc0Q7QUFDdEQsaUVBQWlFO0FBQ2pFLHVEQUF1RDtBQUN2RCxzREFBc0Q7QUFDdEQsaURBQWlEO0FBQ2pELHdEQUF3RDtBQUN4RCxpREFBaUQ7QUFDakQsdURBQXVEO0FBQ3ZELHFFQUFxRTtDQUN0RSxDQUFBO0FBRUQsZUFBZSxTQUFTLENBQUMifQ==